import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import AboutComparison from './components/AboutComparison';
import FeaturesSection from './components/FeaturesSection';
import BlogPreview from './components/BlogPreview';
import SafetySection from './components/SafetySection';
import FinalCTA from './components/FinalCTA';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'itaobuy.hair',
  url: 'https://itaobuy.hair/',
  description: 'The ultimate itaobuyspreadsheet guide for 2026. A structured product comparison system that helps users compare prices, track listings, and make smarter online shopping decisions.',
  inLanguage: 'en',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://itaobuy.hair/?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'itaobuy.hair',
  url: 'https://itaobuy.hair/',
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

export default function Home() {
  return (
    <>
      <SchemaOrg data={websiteSchema} />
      <SchemaOrg data={organizationSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <AboutComparison />
        <FeaturesSection />
        <BlogPreview />
        <SafetySection />
        <FinalCTA />
      </main>
      <Footer />
    </>
  );
}